import React from 'react'
import wireless from "../static/images/wireless.png"

const Banner = () => (
<div className="tw-hero">
  <div className="container">
    <div className="row">
      <div className="col-lg-12">
        <div className="row justify-content-center text-center">
          <div className="col-md-10">
          <img id="wireless-text" src={wireless} alt="wireless" style = {{marginBottom:"40px"}} />
            <h1 className="tw-slider-subtitle">Sales | Repairs | Accessories</h1>
            <h4 className="tw-slider-title"><span>Hamilton's</span> Best Cell Phone Store
              {/* <span>Whiz</span> */}
            </h4> 
          </div>
          {/* End Col */}
        </div>
      </div>
    </div>
  </div>
</div>


)
export default Banner